import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { routes, routes2 } from '@linqpal/models'
import { useInvoiceDetailsContext } from '../../TabInvoice/InvoiceDetailsContext'
import { dispatcher, pathFactory } from '../../../links'
import RootStore, { useStore } from '../../../../store'
import { InsufficientFundsError } from '@linqpal/models/src/types/exceptions'
import { BtButton } from '@linqpal/components/src/ui'

type PaymentButtonProps = {
  invoices: any[]
  account?: any
  method?: any
  // have to pass navigation and contexts due to current ui-kitten bug (no context available in modal). Fixed in latest ui-kitten
  navigation: any
  onSuccess: () => void
  builderCreatedInvoice?: boolean
}

export const PaymentButton: React.FC<PaymentButtonProps> = observer(
  ({
    invoices,
    account,
    method,
    navigation,
    onSuccess,
    builderCreatedInvoice,
  }): JSX.Element => {
    const { t } = useTranslation(['errors', 'global'])

    const {
      setPaymentProcessingModal,
      setInviteSuccessModal,
      setInvoiceStatusModalVisibility,
      setInvoicePaymentStatus,
      setInvoicePaymentMethod,
    } = useInvoiceDetailsContext()

    const { userStore, screensStore } = useStore()

    const onPay = () => {
      onSuccess()
      setInvoicePaymentMethod(account)
      setPaymentProcessingModal(true)
      setInvoicePaymentStatus('')

      if (builderCreatedInvoice) {
        routes.invoices
          .inviteSupplierSchedulePay(
            [invoices[0]._id],
            userStore?.user?.sub,
            account.id,
          )
          .then(() => {
            setPaymentProcessingModal(false)
            setInviteSuccessModal(true)
          })
      } else {
        const invoiceIds = invoices.map((invoice) => invoice._id)
        routes2.invoice
          .pay({
            invoiceIds,
            paymentMethod: method,
            accountId:
              account.paymentMethodType === 'card'
                ? account.cardMetadata.accountId
                : account.id,
            account_id: account.id,
          })
          .then(() => {
            screensStore.notificationStore.fetchNotifications()
            setPaymentProcessingModal(false)
            setInvoicePaymentStatus({ status: 'success' } as any)
            setInvoiceStatusModalVisibility(true)
            setTimeout(() => {
              setInvoiceStatusModalVisibility(false)
              const action = dispatcher(pathFactory('Console.Payables.home'))
              navigation.replace(action.name, action.params)
            }, 4000)
          })
          .catch((e) => {
            console.log('e', e)
            setPaymentProcessingModal(false)
            const result =
              e.response?.data?.result || t('errors:system-failure')

            const status =
              result === InsufficientFundsError.name ||
              e.result === InsufficientFundsError.name
                ? t('errors:insufficient-funds')
                : result === 'LogicalError'
                ? t('errors:error-occurred')
                : t('errors:system-failure')

            const dataMessage =
              e.response?.data?.message ||
              e.data?.message ||
              e.message ||
              e.toString()

            setInvoicePaymentStatus({ status, message: dataMessage } as any)
            setInvoiceStatusModalVisibility(true)
          })
      }
    }

    return (
      <BtButton
        style={{ width: 200 }}
        disabled={RootStore.isBusy}
        loading={RootStore.isBusy}
        onPress={onPay}
      >
        {t('global:payInvoice.agree-and-pay')}
      </BtButton>
    )
  },
)
